import { Grid } from '@material-ui/core'
import React from 'react'
import Tab from '../../components/UI/OrderTabbedPanel/TabbedPanel'
import ReportFive from './ReportFive'
import ReportFour from './ReportFour'
import ReportOne from './ReportOne'
import ReportThree from './ReportThree'
import ReportTwo from './ReportTwo'

const ComplementaryReports = (props) => {
    const tabs = [
        {
            index: 0,
            label: "گزارش شماره 1",
            value: <ReportOne />
        },
        {
            index: 1,
            label: "گزارش شماره 2",
            value: <ReportTwo />
        },
        {
            index: 2,
            label: "گزارش شماره 3",
            value: <ReportThree />
        },
        {
            index: 3,
            label: "گزارش شماره 4",
            value: <ReportFour />
        },
        {
            index: 4,
            label: "گزارش شماره 5",
            value: <ReportFive />
        },
    ]
    return (
        <div className='row justify-content-center'>
            <Grid lg={8} xs={11}>
                <Tab tabs={tabs} />
            </Grid>
        </div>
    )
}

export default ComplementaryReports